module.exports = __webpack_public_path__ + "img/illu-card-beschwerden-pain.50b7fb9e.svg";